import { render, staticRenderFns } from "./CooperationBrands.vue?vue&type=template&id=6f7c6bba&scoped=true&"
import script from "./CooperationBrands.vue?vue&type=script&lang=js&"
export * from "./CooperationBrands.vue?vue&type=script&lang=js&"
import style0 from "./CooperationBrands.vue?vue&type=style&index=0&id=6f7c6bba&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f7c6bba",
  null
  
)

export default component.exports